import * as angular from 'angular';
import template from './SubheaderMenuView.html';
import permissionsJson from 'application/detail/permissions.json';
import './subheaderMenu.scss';
import { BlipStoreFeatures } from 'modules/blipStore/BlipStoreFeatures';
const customSubheaderItemsId = '#custom-subheader-items';
const defaultMenuLimit = 5;
const authApplicationDetailPlugin = 'auth.application.detail.plugin';
const uthBlipStoreTemplate = 'auth.blipStore.template';
let isBlipStoreListPluginsHomeBotServicePageEnabled = false;
let isBlipStoreExtensionsHomeBotServicePageEnabled = false;
class SubheaderMenu {
    static $inject = ['$state', 'CurrentApplicationService', 'SegmentService', 'AiAgentService'];
    constructor($state, CurrentApplicationService, SegmentService, AiAgentService) {
        'ngInject';
        this.$state = $state;
        this.CurrentApplicationService = CurrentApplicationService;
        this.SegmentService = SegmentService;
        this.AiAgentService = AiAgentService;
        this.isAiAgent = false;
    }
    /**
     * Called whenever one-way bindings are updated
     * @param  {any} $changedObjects - bindings that have changes
     */
    async $onChanges($changedObjects) {
        if ($changedObjects.menuItems.currentValue != undefined) {
            this.$menuItems = angular.copy($changedObjects.menuItems.currentValue);
            isBlipStoreListPluginsHomeBotServicePageEnabled = await BlipStoreFeatures.isBlipStoreListPluginsHomeBotServicePageEnabled();
            isBlipStoreExtensionsHomeBotServicePageEnabled = await BlipStoreFeatures.isBlipStoreExtensionsHomeBotServicePageEnabled();
            this.isAiAgent = await this.isAiAgentAsync();
            this.application = await this.CurrentApplicationService.fetchApplication();
            this.$menuItems = this.checkPermissions();
            this.$menuItems = this.checkAiAgent();
            this.createVisibleMenu();
        }
    }
    createVisibleMenu() {
        let menuLimit = defaultMenuLimit;
        if (this.isAiAgent) {
            menuLimit = 4;
        }
        this.filterMenu();
        if (this.$menuItems && this.$menuItems.length > menuLimit) {
            this.visibleMenus = this.$menuItems.slice(0, menuLimit);
            this.dropdownMenus = this.$menuItems.slice(menuLimit, this.$menuItems.length);
        }
        else {
            this.visibleMenus = this.$menuItems;
        }
    }
    filterMenu() {
        if (!isBlipStoreListPluginsHomeBotServicePageEnabled) {
            this.$menuItems = this.$menuItems.filter(menu => (menu.sref != authApplicationDetailPlugin));
        }
        if (!isBlipStoreExtensionsHomeBotServicePageEnabled) {
            this.$menuItems = this.$menuItems.filter(menu => (menu.sref != uthBlipStoreTemplate));
        }
    }
    async isAiAgentAsync() {
        return await this.AiAgentService.checkAiAgentAsync();
    }
    checkAiAgent() {
        if (this.isAiAgent) {
            return this.$menuItems.filter(item => item.displayWhenAiAgent === true);
        }
        else {
            return this.$menuItems.filter(item => item.isAiAgent !== true);
        }
    }
    checkPermissions() {
        const permissionsFile = angular.copy(permissionsJson);
        const allowedClaims = Object.keys(permissionsFile)
            .map((p) => {
            if (!permissionsFile[p].hideInTemplate ||
                !permissionsFile[p].hideInTemplate.includes(this.application.template)) {
                return permissionsFile[p].claim;
            }
        })
            .filter((p) => p);
        return this.$menuItems.reduce((array, item) => {
            const contains = item.claims?.length
                ? item.claims.some((claim) => allowedClaims.includes(claim))
                : true;
            if (contains) {
                return [...array, item];
            }
            else {
                return array;
            }
        }, []);
    }
    async createTrack(trackClick = undefined) {
        if (!trackClick) {
            return;
        }
        try {
            const application = await this.CurrentApplicationService.fetchApplication();
            this.SegmentService.createApplicationTrack({
                trackEvent: trackClick,
                application,
            });
        }
        catch (e) {
            console.error(e);
        }
    }
}
SubheaderMenu.$inject = ['$state', 'CurrentApplicationService', 'SegmentService', 'AiAgentService'];
export const SubheaderMenuComponent = {
    template: template,
    controllerAs: '$ctrl',
    controller: SubheaderMenu,
    transclude: true,
    bindings: {
        menuItems: '<',
    },
};
